import {
    monaco
} from 'react-monaco-editor';

const fnHints = function (range) {
    // returning a static list of proposals, not even looking at the prefix (filtering is done by the Monaco editor),
    // here you could do a server side lookup
    return [{
            label: 'rcu',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: `函数库`,
            insertText: 'rcu',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetLeftButton',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: `判断控制器左侧按键是否被按\n\n返回值：按下时返回数值1，未按下时返回数值0`,
            insertText: 'GetLeftButton',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetRightButton',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "判断控制器右侧按键是否被按下\n\n返回值：按下时返回数值1，未按下时返回数值0",
            insertText: 'GetRightButton',
            range: range

        },
        {
            label: 'GetInMic',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "读取控制器内置麦克风检测的声音大小值",
            insertText: 'GetInMic',
            range: range
        },
        {
            label: 'GetInVotage',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "读取控制器此时电源电压值\n\n返回值：0-100，当数据为84，电压为8.4V",
            insertText: 'GetInVotage',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetSysTime',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "读取程序运行至今的时间\n\n返回值：数值为毫秒单位，数值1000时为1秒",
            insertText: 'GetSysTime',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetSysTime',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "控制器运行程序后，内置时钟归零。",
            insertText: 'SetSysTime',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetInBeep',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "开启或关闭蜂鸣器\n\n参数值:参数为1时蜂鸣器开启，参数为0时蜂鸣器关闭",
            insertText: 'SetInBeep',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetInSound',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "设置蜂鸣器的音调以及播放时长\n\n参数值：1-1976，音调值\n参数值：0-2，播放音调时间",
            insertText: 'SetInSound',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetData',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "读取控制器内置数据的数值\n\n参数值：1-156，对应内置地址名称\n返回值：控制器内置地址数据值",
            insertText: 'GetData',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetData',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "将控制器指定内置数据设为指定值\n\n参数值：1-156，对应内置地址名称\n参数值：1-4095，赋予内置地址数据值",
            insertText: 'SetData',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetMotor',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "使马达以指定速度运转\n\n参数值：1-4，马达连接端口\n参数值：-100-100，马达速度。数值越大速度越快，0停止，小于0反转，大于0正转",
            insertText: 'SetMotor',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetMotorCode',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "读取马达编码器数值，起到记录马达转动角度的作用。\n\n参数值：1-4，马达连接端口\n返回值：马达转动的角度值，数值1代表转动1度，有正负区分。",
            insertText: 'GetMotorCode',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetMotorCode',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "将编码器记录的数值清零\n\n参数值：1-4，马达连接端口",
            insertText: 'SetMotorCode',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetMotorServo',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "设置马达转动到指定角度\n\n参数值：1-4，马达连接端口\n参数值：-100-100，马达速度\n参数值：0-3600，马达旋转的角度",
            insertText: 'SetMotorServo',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetWaitForAngle',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "等待马达转动到指定角度，再执行下方程序\n\n参数值：1-4，马达连接端口\n参数值：-100-100，马达速度\n参数值：0-3600，马达旋转的角度",
            insertText: 'SetWaitForAngle',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetMotorStraightAngle',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "使两个马达同步转动\n\n参数值：1-4，马达连接端口\n参数值：1-4，马达连接端口\n参数值：-100-100，马达速度\n参数值：0-2147483647，马达旋转的脉冲",
            insertText: 'SetMotorStraightAngle',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetCarTurn',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "使两个马达同步反向转动\n\n参数值：1-4，马达连接端口\n参数值：1-4，马达连接端口\n参数值：-100-100，马达速度\n参数值：0-2147483647，马达旋转的脉冲",
            insertText: 'SetCarTurn',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetMotorPower',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "将多个马达设置为指定功率运转\n\n参数值:-100-100，各马达运转速度",
            insertText: 'SetMotorPower',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetTouch',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "判断触碰传感器是否被按下。\n\n参数值：1-8，传感器端口\n返回值：0/1。按下返回1，否则返回0。",
            insertText: 'GetTouch',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetLightSensor',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "判断光电传感器检测的物体颜色深度是否小于阈值。\n\n参数值：1-8，传感器端口\n返回值：0/1，低于阈值返回1，否则返回0",
            insertText: 'GetLightSensor',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetColorSensor',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "读取颜色传感器检测物体的颜色值。\n\n参数值：1-8，传感器端口\n返回值：1-6，对应红、绿、蓝、黄、黑、白",
            insertText: 'GetColorSensor',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetUltrasound',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "读取超声传感器与障碍物的距离值.\n\n参数值：1-8，传感器端口\n返回值：7-180",
            insertText: 'GetUltrasound',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'Set3CLed',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "设置彩灯模块的显示颜色。\n\n参数值：1-8，传感器端口\n参数值：0-7，对应关灯、红、绿、蓝、黄、紫、青、白色",
            insertText: 'Set3CLed',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetCamRecog',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "设置WIFI摄像头识别数据\n\n参数值：5-12，分别对应8种模式\n返回值：5-9模式，0-255；10-12模式，-100~100",
            insertText: 'GetCamRecog',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetAICamData',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "设置摄像头模块数据的位数\n\n参数值：1-14，可选取14种位数据\n返回值：0-255",
            insertText: 'GetAICamData',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetAICamData',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "设置AI视觉模块识别模式，通过下拉选项选择对应模式\n\n参数值：1-8；\n1是关、2是颜色识别、3是二维码识别、4是小球识别、5是道路识别、6是人脸识别、7是标志识别、8是标签识别、9颜色识别学习、10人脸识别学习、11手势识别学习、12图像分类识别学习、13道路标志识别",
            insertText: 'SetAICamData',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetWifiCamRockCtrlNew',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "读取WIFI摄像头摇杆值左右摇杆X轴与左右摇杆Y轴数据，通过下拉选项选择对应模式\n\n参数值：0-3；0为左摇杆X轴，1为左摇杆Y轴，2为右摇杆X轴，3为右摇杆Y轴。\n数值范围：-100~100",
            insertText: 'GetWifiCamRockCtrlNew',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetWifiPictureData',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "读取WIFI摄像头检测结果，通过下拉选项选择对应模式\n\n参数值：0-3；0为二维码ID，1为图像面积，2为图像X坐标，3为图像Y坐标。\n 数值范围：-100~100",
            insertText: 'GetWifiPictureData',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetWifiCamPictureResult',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "读取WIFI摄像头检测图像，通过下拉选项选择对应模式\n\n参数值：0/1；0为人脸，1为二维码。",
            insertText: 'GetWifiCamPictureResult',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetWifiCamPictureSize',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "检测WIFI摄像头图像尺寸大小，通过下拉选项选择对应模式\n\n参数：0-2；0为大，1为中，2为小。\n返回值：0/1",
            insertText: 'GetWifiCamPictureSize',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetWifiCamPictureSite',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "检测WIFI摄像头图像位置，通过下拉选项选择对应模式\n\n参数：0-4；0为上，1为下，2为左，3为右，4为中。\n返回值：0/1",
            insertText: 'GetWifiCamPictureSite',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetTouchScreen',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "判断屏幕是否被触摸\n\n返回值：1/0，触摸时返回数值1，未触摸时返回数值0",
            insertText: 'GetTouchScreen',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetTouchScreenX',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "读取屏幕触摸点的X轴坐标值\n\n" +
                "返回值：1-240,屏幕由左向右，数值由小至大，无触摸时值为0",
            insertText: 'GetTouchScreenX',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetTouchScreenY',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "读取屏幕触摸点的Y轴坐标值\n\n" +
                "返回值：1-320，屏幕由下至上，数值由小至大，无触摸时值为0",
            insertText: 'GetTouchScreenY',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetLCDClear',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "清除显示屏全部的显示数据，背景颜色设置成黄色\n\n" +
                "参数值：0xF800、0x07E0、0x001F、0xFFE0、0xF81F、0x07FF、0xFFFF、0x0000，对应红绿蓝黄紫青白黑色",
            insertText: 'SetLCDClear',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetFontSize',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "设置屏幕显示字体大小\n\n" +
                "参数值：0-4",
            insertText: 'SetFontSize',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetDisplayVar',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "在显示屏设定的行位置显示数字，显示方式为左对齐\n\n" +
                "参数值：1-20\n" +
                "参数值：能输入最长30个要显示的数字",
            insertText: 'SetDisplayVar',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetDisplayString',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "在显示屏设定的行位置显示字符，显示方式为左对齐\n\n" +
                "参数值：1-20\n" +
                "参数值：能输入最长30个要显示的数字、英文字母、符号、空格",
            insertText: 'SetDisplayString',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetDisplayPicture',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "在显示屏设定的坐标位置显示图片，起始位置为图片的左上角\n\n" +
                "参数值：1-240，X坐标\n" +
                "参数值：1-320，Y坐标\n" +
                "参数值：文件名\n" +
                "参数值：0-3；0是不缩放，1是缩放1/2，2是缩放1/4,3是缩放1/8",
            insertText: 'SetDisplayPicture',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetDisplayVarXY',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "在显示屏设定的坐标位置显示数字，数字和背景颜色可设定\n\n" +
                "参数值：1-240，X坐标\n" +
                "参数值：1-320，Y坐标\n" +
                "参数值：能输入最长30个要显示的数字\n" +
                "参数值：字体颜色\n" +
                "参数值：背景颜色",
            insertText: 'SetDisplayVarXY',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetDisplayStringXY',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "在显示屏设定的坐标位置显示数字，数字和背景颜色可设定，可将背景设置为是否透明\n\n" +
                "参数值：1-240，X坐标\n" +
                "参数值：1-320，Y坐标\n" +
                "参数值：能输入最长30个要显示的数字、英文字母、符号、空格\n" +
                "参数值：字体颜色\n" +
                "参数值：背景颜色\n" +
                "参数值：0是不透明，1是透明",
            insertText: 'SetDisplayStringXY',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetLCDDot',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "在显示屏设定的坐标位置显示一个坐标点\n\n" +
                "参数值：1-240，X坐标\n" +
                "参数值：1-320，Y坐标\n" +
                "参数值：点的颜色",
            insertText: 'SetLCDDot',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetLCDLine',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "从显示屏设定的坐标位置开始，朝设定的角度方向绘制一条线段\n\n" +
                "参数值：1-240，X坐标\n" +
                "参数值：1-320，Y坐标\n" +
                "参数值：0-360\n" +
                "参数值：一个单位长度等于一个点\n" +
                "参数值：线段颜色",
            insertText: 'SetLCDLine',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetLCDSolidCircle',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "以显示屏设定的坐标位置为圆心，绘制一个实心圆形\n\n" +
                "参数值：1-240，X坐标\n" +
                "参数值：1-320，Y坐标\n" +
                "参数值：一个单位半径长度等于一个点\n" +
                "参数值：圆的颜色",
            insertText: 'SetLCDSolidCircle',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetLCDRectangle2',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "绘制一个空心矩形，左上角为显示屏设定的坐标位置\n\n" +
                "参数值：1-240，X坐标\n" +
                "参数值：1-320，Y坐标\n" +
                "参数值：1-240，宽\n" +
                "参数值：1-320，高\n" +
                "参数值：一个单位线宽等于一个点的宽\n" +
                "参数值：线的颜色",
            insertText: 'SetLCDRectangle2',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetLCDFilledRectangle2',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "绘制一个实心矩形，左上角为显示屏设定的坐标位置\n\n" +
                "参数值：1-240，X坐标\n" +
                "参数值：1-320，Y坐标\n" +
                "参数值：1-240，宽\n" +
                "参数值：1-320，高\n" +
                "参数值：矩形的颜色",
            insertText: 'SetLCDFilledRectangle2',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetMp3Play',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "播放MP3磁盘中01文件夹内名称为01的MP3\n\n" +
                "参数：01-99文件夹名称\n" +
                "参数：01-99音频文件名称",
            insertText: 'SetMp3Play',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetMp3Suspend',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "中断MP3的播放",
            insertText: 'SetMp3Suspend',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetWaitForTime',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "等待指定时间后，执行其后程序。\n\n" +
                "参数值：等待时间，单位为秒",
            insertText: 'SetWaitForTime',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetBluetoothData',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "控制器通过蓝牙接收另一个控制器发送过来的数据\n\n" +
                "返回值：0-255",
            insertText: 'GetBluetoothData',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetBluetoothData',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "控制器通过蓝牙向另一个控制器发送数据\n\n" +
                "参数值：0-255",
            insertText: 'SetBluetoothData',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetComVoice',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "通过WIFI模块接收APP软件语音数据，与关键词比较返回识别结果。\n\n" +
                "参数值：语音识别关键词可以为中文，英文字母和数字，关键词中文不能超过28个，英文和数字不能超过56个。\n" +
                "返回值：0/1，0是语音数据与关键词不匹配，1是语音数据与关键词匹配",
            insertText: 'GetComVoice',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetBluetoothControl',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "读取手机蓝牙键码\n\n" +
                "返回值：0-256，其中0表示未按下",
            insertText: 'GetBluetoothControl',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetBluetoothControlData',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "读取手机蓝牙键值\n\n" +
                "返回值：0-12，其中0表示未按下",
            insertText: 'GetBluetoothControlData',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetBTModuleRemoteButton',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "读取蓝牙手柄键码\n\n" +
                "返回值：有数据时返回0-39，无数据时返回999",
            insertText: 'GetBTModuleRemoteButton',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetBTModuleRemoteCode',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "读取蓝牙手柄键值\n\n" +
                "返回值：有数据时返回32bit的长度数据，无数据时返回0",
            insertText: 'GetBTModuleRemoteCode',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetBTModuleRemoteRocker',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "读取蓝牙手柄的左、右摇杆值\n\n" +
                "参数值：0为读左摇杆值，1为读右摇杆值\n" +
                "参数值：0为读摇杆X轴值，1为读摇杆Y轴值\n" +
                "返回值：-100-100，无数据时返回999",
            insertText: 'GetBTModuleRemoteRocker',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetRandom',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: "在指定区间内取随机数\n\n" +
                "返回值：指定区间内的随机数",
            insertText: 'GetRandom',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetDisplayInt',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'SetDisplayInt',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetDisplayStr',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'SetDisplayStr',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetMotorStraight',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'SetMotorStraight',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetWaitForAICamData',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'SetWaitForAICamData',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetAICamData',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'SetAICamData',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetAICamLED',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'SetAICamLED',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetAICamVoice',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'GetAICamVoice',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetFaceRegister',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'SetFaceRegister',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetFaceRegisterData',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'GetFaceRegisterData',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetAHRS',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'GetAHRS',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetAHRS',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'SetAHRS',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetSmartEyeDist',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'GetSmartEyeDist',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetSmartEyeIRcode',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'GetSmartEyeIRcode',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetSmartEyeIRcode',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'SetSmartEyeIRcode',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetSmartEyeAllLed',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'SetSmartEyeAllLed',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetSmartEyeMode',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'SetSmartEyeMode',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetLaserDist',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'GetLaserDist',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetShortIRDist',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'GetShortIRDist',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetGesture',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'GetGesture',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetDisplayLatticePic',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'SetDisplayLatticePic',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetDisplayLattice',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'SetDisplayLattice',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetDisplayLatticeString',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'SetDisplayLatticeString',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetDisplayLatticeXY',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'SetDisplayLatticeXY',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetDisplayLatticeClear',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'SetDisplayLatticeClear',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetAirPressure',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'GetAirPressure',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetSht30',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'GetSht30',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetMagnetic',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'GetMagnetic',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetScanCamera',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'GetScanCamera',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetComStrCompare',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'GetComStrCompare',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetTraceV2I2C',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'GetTraceV2I2C',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetRFPassWord',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'SetRFPassWord',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'SetRFModuleByte',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'SetRFModuleByte',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetRFModuleByte',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'GetRFModuleByte',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetRFModuleRemoteButton',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'GetRFModuleRemoteButton',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetRFModuleRemoteCode',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'GetRFModuleRemoteCode',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetRFModuleRemoteGravity',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'GetRFModuleRemoteGravity',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetRFModuleRemoteRocker',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'GetRFModuleRemoteRocker',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'GetRFModuleRemoteBit',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'GetRFModuleRemoteBit',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'WaitTouchReleased',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'WaitTouchReleased',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'WaitTouchPressed',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'WaitTouchPressed',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'WaitLeftButtonReleased',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'WaitLeftButtonReleased',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'WaitLeftButtonPressed',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'WaitLeftButtonPressed',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'WaitRightButtonReleased',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'WaitRightButtonReleased',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        },
        {
            label: 'WaitRightButtonPressed',
            kind: monaco.languages.CompletionItemKind.Function,
            detail: `说明>`,
            documentation: '',
            insertText: 'WaitRightButtonPressed',
            insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
            range: range
        }
    ];
}

export default fnHints
